export default "<div class=\"table-header\" *ngIf=\"isEnabled()\">\n  <span flex>{{tableHeader.title}}</span>\n</div>"